import { arrivalTimes } from './arrivalTimes';
import { baseSpaDay } from './baseSpaDay';
import { extras } from './extras';
import { inclusionsWithTimes } from './inclusions';
import { selectionsWithTimes } from './selections';

// Spa Package with arrival times, time slots supported but not required and a choice of options
export const scenario3 = {
  ...baseSpaDay,
  ...arrivalTimes,
  configurationGroupsRequireTimeslots: false,
  configurationGroupsSupportTimeslots: true,
  configurationGroups: [...inclusionsWithTimes, ...selectionsWithTimes, ...extras],
};
